/* eslint-disable import/no-cycle */
import React from 'react';
import { Control, DeepMap, FieldError } from 'react-hook-form';
import ContactBody from './ContactBody';

const CustomerBody = ({
  control,
  onChange,
  errors,
}: {
  //    eslint-disable-next-line
  control: Control<Record<string, any>>;
  //    eslint-disable-next-line
  onChange: (name: string, value: any, config?: Object) => void;
  //    eslint-disable-next-line
  errors?: DeepMap<Record<string, any>, FieldError>;
}) => {
  return (
    <ContactBody
      control={control}
      onChange={onChange}
      errors={errors}
      isCustomer
    />
  );
};

export default CustomerBody;
